module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-form-select-container",
    class: [_vm.marginClasses, _vm.sizeClasses]
  }, [_c('div', {
    staticClass: "sc-select-box sc-year-select",
    class: {
      'sc-select-has-error': _vm.error, disabled: _vm.disabledClass
    }
  }, [_c('div', {
    ref: (_vm.computedName + "-sc-selectbox"),
    staticClass: "sc-select-button brd",
    class: {
      'open-select-box': _vm.showOptions,
    },
    on: {
      "click": function($event) {
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('div', {
    staticClass: "sc-selected-value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.select_query),
      expression: "select_query"
    }],
    staticClass: "sc-select-input sc-year",
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.select_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.select_query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sc-select-chevrons"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/symbols-arrow.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeInTop",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptions),
      expression: "showOptions"
    }, {
      name: "closable",
      rawName: "v-closable",
      value: ({
        exclude: [(_vm.computedName + "-sc-selectbox")],
        handler: 'onClose',
      }),
      expression: "{\n          exclude: [`${computedName}-sc-selectbox`],\n          handler: 'onClose',\n        }"
    }],
    staticClass: "sc-options",
    attrs: {
      "id": (_vm.computedName + "-sc-options")
    }
  }, [_c('div', {
    staticClass: "sc-option sc-option-placeholder"
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v(_vm._s(_vm.placeholder))])]), _vm._v(" "), (_vm.options.length) ? _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      key: _vm.id + '_' + index + '_' + option,
      staticClass: "sc-option",
      class: {
        'sc-selected': _vm.value == option
      },
      on: {
        "click": function($event) {
          return _vm.handleInput(index)
        }
      }
    }, [_c('span', {
      staticClass: "sc-select-option-label"
    }, [_vm._v(_vm._s(option))])])
  }) : [_c('div', {
    staticClass: "sc-option"
  }, [_c('span', {
    staticClass: "sc-select-option-label"
  }, [_vm._v("Nothing found")])])]], 2)])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "input-error"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Error.svg"),
      "alt": "Error"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [(_vm.success) ? _c('div', {
    staticClass: "input-checked"
  }, [_c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/Checked.svg"),
      "alt": "Checked"
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27573cb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseYearSelect.vue
// module id = 107
// module chunks = 0